import { ClickAwayListener } from "@mui/base/ClickAwayListener";
import { Box, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { DataResult, process as kendoProcess, State } from "@progress/kendo-data-query";
import { mapTree } from "@progress/kendo-react-common";
import {
  GridColumn as Column,
  GridColumnMenuWrapper,
  GridColumnProps,
  GridColumnReorderEvent,
  GridContextMenuEvent,
  GridDataStateChangeEvent,
  GridDetailRowProps,
  GridEvent,
  GridExpandChangeEvent,
  GridHeaderCellProps,
  GridRowClickEvent
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import parse from 'html-react-parser';
import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { getParamValue } from "../../commons/helpers/ObjectHelper";
import { padZerosLeft } from "../../commons/helpers/StringHelper";
import sizeConfigs from "../../configs/sizeConfigs";
import { formatDate } from "../../constante/generic";
import { headers } from "../../constante/headers/planoGoupeHeader";
import { Keys } from "../../constante/keys";
import { PTR_LENGTH } from "../../constante/produits";
import { ResponseTypes } from "../../constante/responseTypes";
import { sortableFields } from "../../constante/sortableFields";
import { RECH, UrlParams } from "../../constante/UrlParams";
import { APIError } from "../../errors/APIError";
import useGetPollingInterval from "../../hooks/useGetPollingInterval";
import useUrlParamsHandler from "../../hooks/useUrlParamsHandler";
import { useUserPreferences } from "../../hooks/useUserPreferences";
import { Activite } from "../../models/Activite";
import { Banniere } from "../../models/Banniere";
import { Collection } from "../../models/Collection";
import { Division } from "../../models/Division";
import { Fournisseur } from "../../models/Fournisseur";
import { GroupProduit } from "../../models/GroupProduit";
import { Header } from "../../models/Header";
import { Magasin } from "../../models/Magasin";
import { Produit } from "../../models/Produit";
import { Section } from "../../models/Section";
import { Statut } from "../../models/Statut";
import { User } from "../../models/User";
import { addNotificationMessages } from "../../redux/features/appStateSlice";
import {
  planoAPI,
  useGetActivitesQuery,
  useGetBannieresQuery,
  useGetCollectionsQuery,
  useGetDivisionsQuery,
  useGetFournisseursQuery,
  useGetMagasinsQuery,
  useGetPlanogrammeQuery,
  useGetSectionsQuery,
  useGetStatutQuery,
  useGetUsersQuery,
  useLazyGetPlanoQuery
} from "../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { CustomColumnMenu } from "../grid/CustomColumnMenu";
import CustomGrid from "../grid/CustomGrid";
import GridWrapper from "../grid/GridWrapper";
import { getModalStyle } from "../modalStyle";
import DetailComponent from "./components/DetailComponent";
import FormNewProduit from "./components/Forms/FormNewProduit";
import HeaderPlano from "./components/HeaderPlano";
import StatsModalComponent from "./components/StatsModalComponent";
import Toolbar from "./components/Toolbar";
import { WrapperEditMagasin } from "./components/WrapperEditMagasin";
import WrapperMagasin from "./components/WrapperMagasin";
import GenericModal from "./modals/GenericModal";
import "./style.css";
import React from "react";
import { customCellFeed } from "../../components/commons/grid-cell/cellRegistry";

export const GridContext = createContext<{
  selectedData: any | null,
  updateRow: Function
} | null>(null);

export const PlanogrammePage = () => {

  const dispatch = useAppDispatch();
  const urlParamsHandler = useUrlParamsHandler();
  const userPreferencesHook = useUserPreferences();

  const [user, setUser] = useState<string>("");
  const [ban, setBan] = useState<string>("");
  const [mag, setMag] = useState<string>("");
  const [div, setDiv] = useState<string>("");
  const [section, setSection] = useState<string>("");
  const [four, setFour] = useState<string>("");
  const [currentAcc, setCurrentAcc] = useState<string>("");
  const [statut, setStatut] = useState<string>("");
  const [collection, setCollection] = useState<string>("");

  const [rech, setRech] = useState<string>(urlParamsHandler.getParams(RECH));

  const [listMags, setListMags] = useState<Magasin[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(100);
  const [open, setOpen] = useState(false);
  const [openNewProduit, setOpenNewProduit] = useState<boolean>(false);
  const [openRemplacePar, setOpenRemplacePar] = useState<boolean>(false);
  const [toSort, setToSort] = useState<string>("");
  const [order, setOrder] = useState<string>("");

  const [columns, setColumns] = useState<Header[]>([]);

  const handleCloseNewProduit = () => {
    setOpenNewProduit(false);
    setAddProductTitle("");
    setAnchorEl(null);
    dispatch(planoAPI.util.invalidateTags(["planogramme", "plano"]));
  };
  const [openModalStats, setOpenModalStats] = useState(false);
  const handleCloseModalStats = () => {
    setSelectedRow(null);
    setOpenModalStats(false);
    setAnchorEl(null);
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const [activeSectionNum, setActiveSectionNum] = useState<number>(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showContextualMenu, setShowContextualMenu] = useState<boolean>(false);
  const [prev, setPrev] = useState<number>(0);
  const [showAddMagasinMenu, setShowAddMagasinMenu] = useState(false);
  const [showAddMagasin, setShowAddMagasin] = useState(false);
  const buttonsState = useAppSelector((state) => state.appState.buttonsState);
  const headerExpanded = useAppSelector(
    (state) => state.appState.planoHeaderExpanded
  );
  const [groupBys, setGroupBys] = useState<string[]>(
    buttonsState.productView
      ? ["div_nom", "plans_nom"]
      : ["div_nom", "plans_nom", "mag_nom"]
  );

  const [activeMagasin, setActiveMagasin] = useState("");
  const [activeMagasinNum, setActiveMagasinNum] = useState(0);
  const [collapsedGroups, setCollapsedGroups] = useState<string[]>([]);
  const [openModalEdit, setOpenModalEdit] = useState<boolean>(false);
  const pollingInterval = useGetPollingInterval();
  const modalOpened = useAppSelector((state) => state.appState.modalsOpened);
  const initialdataState: State = useMemo(() => {
    return {
      group: groupBys.map((item) => ({ field: item, dir: undefined })),
    };
  }, [groupBys]);

  const mode = useMemo(() => {
    return buttonsState.productView ? "" : "MagProd"
  }, [buttonsState.productView]);

  const {
    data: planogrammes = [] as GroupProduit[],
    isFetching: isFetchingPlanogrammes,
    isLoading,
    isSuccess: isSuccessPlanogrammes,
    isError,
    error,
  } = useGetPlanogrammeQuery(
    {
      first: groupBys.join(","),
      mag,
      banniere: ban,
      section,
      four,
      div,
      page,
      rech,
      limite: pageSize,
      acht: user,
      act: currentAcc,
      toSort,
      order,
      statut,
      mode,
      coll: collection,
    },
    { pollingInterval: pollingInterval }
  );

  const [groupProduit, setGroupProduit] = useState<GroupProduit[]>([]);

  useEffect(() => {
    if (!isFetchingPlanogrammes) {
      setGroupProduit(planogrammes);
    }
  }, [isFetchingPlanogrammes, planogrammes]);

  const prod_plano = useAppSelector((state) => state.appState.prod_plano);
  const d_inv170 = useAppSelector((state) => state.appState.d_inv170);

  const { data: divisions = [] as Division[], isSuccess: isSuccessDivisions } = useGetDivisionsQuery({
    treeView: true,
    includeSections: true,
    user: user,
    plano: true,
  });
  const { data: magasins = [] as Magasin[], isSuccess: isSuccessMagasins } = useGetMagasinsQuery({
    banniere: "",
    treeView: true,
  });
  const { data: bannieres = [] as Banniere[], isSuccess: isSuccessBannieres } = useGetBannieresQuery({
    InclMag: false,
    treeView: true,
  });
  const { data: activites = [] as Activite[], isSuccess: isSuccessActivites } = useGetActivitesQuery(true);

  // TODO: see Footer.tsx
  // const { data: footer = { plans_seq: 0, nbVise: "0/0", ptrCount: "0" } } =
  //   useGetFooterQuery({
  //     plan: activeSectionNum,
  //     first: fields,
  //     mag: buttonsState.storeView ? activeMagasinNum.toString() : mag,
  //     banniere: ban,
  //     section,
  //     four,
  //     div,
  //     page,
  //     rech,
  //     limite: pageSize,
  //     acht: user,
  //     act: currentAcc,
  //     toSort,
  //     order,
  //     statut,
  //   });

  const { data: users = [] as User[], isSuccess: isSuccessUsers } = useGetUsersQuery({
    fonction: "Plano",
    sort: "usr_nom",
    div_num: div,
  });
  const { data: sections = [] as Section[], isSuccess: isSuccessSections } = useGetSectionsQuery({
    div,
    simple: true,
    user: "",
    rech: "",
    treeView: true,
  });
  const { data: statuts = [] as Statut[], isSuccess: isSuccessStatuts } = useGetStatutQuery(true);
  const { data: fournisseurs = [], isSuccess: isSuccessFournisseurs } = useGetFournisseursQuery({
    withMod: "true",
    rech: "",
    treeView: true,
  });
  const { data: collections = [], isSuccess: isSuccessCollections } = useGetCollectionsQuery({
    four: "",
    mod: "",
    treeView: true,
  });

  const [trigger] = useLazyGetPlanoQuery();

  const [dataState, setDataState] = useState<State>(initialdataState);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const [selectedProduct, setSelectedProduct] = useState<GroupProduit>();

  const [activeSection, setActiveSection] = useState("");

  const [dataResult, setDataResult] = useState<DataResult>(
    kendoProcess(groupProduit, dataState)
  );

  useEffect(() => {
    setDataResult(kendoProcess(groupProduit, dataState));
  }, [dataState, groupProduit]);

  const [unsaved, setUnsaved] = useState<boolean>(false);
  const [addProductTitle, setAddProductTitle] = useState<string>("");
  const acheteursSelected = useMemo(() => {
    return users.filter((u) => {
      let currentUsers = user.split(",");
      return currentUsers.includes(u.usr_cd);
    });
  }, [user, users]);
  const bannieresSelected = useMemo(() => {
    return bannieres.filter((e) => {
      let currentBannieres = ban.split(",");
      return currentBannieres.includes(e.maggrp_cd);
    });
  }, [ban, bannieres]);
  const magasinsSelected = useMemo(() => {
    return magasins.filter((e) => {
      let currentMagasins = mag.split(",");
      return currentMagasins.includes(e.mag_num.toString());
    });
  }, [mag, magasins]);
  const divisionsSelected = useMemo(() => {
    return divisions.filter((e) => {
      let currentDivisions = div.split(",");
      return currentDivisions.includes(e.div_num.toString());
    });
  }, [div, divisions]);
  const sectionsSelected = useMemo(() => {
    return sections.filter((e) => {
      let currentSections = section.split(",");
      return currentSections.includes(e.plans_seq.toString());
    });
  }, [section, sections]);
  const activitesSelected = useMemo(() => {
    return activites.filter((e) => {
      let currentActivites = currentAcc.split(",");
      return currentActivites.includes(e.act_cd.toString());
    });
  }, [activites, currentAcc]);
  const statutsSelected = useMemo(() => {
    return statuts.filter((e) => {
      let currentStatuts = statut.split(",");
      return currentStatuts.includes(e.statut_aff.toString());
    });
  }, [statut, statuts]);
  const fournisseursSelected = useMemo(() => {
    return fournisseurs.filter((e) => {
      let currentFournisseurs = four.split(",");
      return currentFournisseurs.includes(e.four_cd);
    });
  }, [four, fournisseurs]);
  const collectionsSelected = useMemo(() => {
    return collections.filter((e) => {
      let currentCollections = collection.split(",");
      return currentCollections.includes(e.prod_collection);
    });
  }, [collection, collections]);

  const resetPage = useCallback(() => {
    if (page > 1) setPage(1);
  }, [page, setPage]);

  const updateObject = useCallback(
    (
      object: any,
      currentValues: any[],
      key: string,
      update: any,
      name: string
    ) => {
      const newValue = getParamValue(currentValues, object, key);
      resetPage();
      update(newValue);
      urlParamsHandler.setParamsToUrl(name, newValue);

      userPreferencesHook.setFilterPreferences(name, newValue);
    },
    [resetPage, urlParamsHandler, userPreferencesHook]
  );

  const bannieresChildren = useMemo(
    () => [
      (banniere: Banniere) =>
        updateObject(
          banniere,
          bannieresSelected,
          Keys.Banniere,
          setBan,
          UrlParams.Banniere
        ),
      (magasin: Magasin) =>
        updateObject(
          magasin,
          magasinsSelected,
          Keys.Magasin,
          setMag,
          UrlParams.Magasin
        ),
    ],
    [bannieresSelected, magasinsSelected, updateObject]
  );

  const divisionsChildren = useMemo(
    () => [
      (division: Division) =>
        updateObject(
          division,
          divisionsSelected,
          Keys.Division,
          setDiv,
          UrlParams.Division
        ),
      (newSection: Section) =>
        updateObject(
          newSection,
          sectionsSelected,
          Keys.Section,
          setSection,
          UrlParams.Section
        ),
    ],
    [divisionsSelected, sectionsSelected, updateObject]
  );

  const fournisseursChildren = useMemo(
    () => [
      (fournisseur: Fournisseur) =>
        updateObject(
          fournisseur,
          fournisseursSelected,
          Keys.Fournisseur,
          setFour,
          UrlParams.Fournisseur
        ),
    ],
    [fournisseursSelected, updateObject]
  );
  const statutsChildren = useMemo(
    () => [
      (newStatut: Statut) =>
        updateObject(
          newStatut,
          statutsSelected,
          Keys.Statut,
          setStatut,
          UrlParams.Statut
        ),
    ],
    [statutsSelected, updateObject]
  );
  const activitesChildren = useMemo(
    () => [
      (activite: Activite) =>
        updateObject(
          activite,
          activitesSelected,
          Keys.Activite,
          setCurrentAcc,
          UrlParams.Activite
        ),
    ],
    [activitesSelected, updateObject]
  );
  const collectionsChildren = useMemo(
    () => [
      (collection: Collection) =>
        updateObject(
          collection,
          collectionsSelected,
          Keys.Collection,
          setCollection,
          UrlParams.Collection
        ),
    ],
    [collectionsSelected, updateObject]
  );

  useEffect(() => {
    if (anchorEl !== null) setShowContextualMenu(true);
  }, [anchorEl]);

  useEffect(() => {
    setGroupBys(
      buttonsState.productView
        ? ["div_nom", "plans_nom"]
        : ["div_nom", "plans_nom","mag_nom"]
    );
  }, [buttonsState]);

  useEffect(() => {
    setDataState(initialdataState);
  }, [initialdataState]);

  useEffect(() => {
    if (groupProduit.length > 0) {
      if (activeSection === "" || groupProduit.length === 1) {
        setActiveSection(groupProduit[0].plans_nom);
        setActiveSectionNum(groupProduit[0].plans_seq);
      }
      if (
        (activeMagasin === "" || groupProduit.length === 1) &&
        buttonsState.storeView
      ) {
        setActiveMagasin(groupProduit[0].mag_nom);
        setActiveMagasinNum(groupProduit[0].mag_num);
      }
      const transformedGroupProduit = groupProduit.map((e) => {
        return {
          ...e,
          plano_dt_deb: formatDate(e.plano_dt_deb),
        };
      });
      setDataResult(kendoProcess(transformedGroupProduit, dataState));
    }
  }, [activeMagasin, activeSection, buttonsState.storeView, dataState, groupProduit]);

  useEffect(() => {
    setUser(() => urlParamsHandler.getParams(UrlParams.Acheteur));
    setBan(() => urlParamsHandler.getParams(UrlParams.Banniere));
    setMag(() => urlParamsHandler.getParams(UrlParams.Magasin));
    setSection(() => urlParamsHandler.getParams(UrlParams.Section));
    setDiv(() => urlParamsHandler.getParams(UrlParams.Division));
    setFour(() => urlParamsHandler.getParams(UrlParams.Fournisseur));
    setCurrentAcc(() => urlParamsHandler.getParams(UrlParams.Activite));
    setStatut(() => urlParamsHandler.getParams(UrlParams.Statut));
    setCollection(() => urlParamsHandler.getParams(UrlParams.Collection));
  }, [urlParamsHandler]);

  useEffect(() => {
    const parsedUserPreferences = userPreferencesHook.getUserPreferences();

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.toString() === "") {
      urlParamsHandler.setSearchParamsToUrl(new URLSearchParams(parsedUserPreferences.planogrammeFilters));
    }

    const preferedColumns = parsedUserPreferences.planogrammeColumns;

    if (preferedColumns) {

      // Combine default headers with user preferences on columns
      const mergedColumns = preferedColumns
        .map(preferedColumn => {
          const header = headers.find(header => header.field === preferedColumn.field);

          if (header) {
            return {
              ...header,
              isDisplayed: preferedColumn.isDisplayed,
              width: preferedColumn.width
            } as Header;
          }

          return null;
        })
        .filter((header): header is Header => header !== null);
      
      const preferedColumnsFields = new Set(preferedColumns.map(col => col.field));
      const remainingColumns = headers.filter(header => !preferedColumnsFields.has(header.field));
      
      const finalColumns = [...mergedColumns, ...remainingColumns];

      setColumns(finalColumns);
    }
    else {
      setColumns(headers);
    }
  }, []);

  const handleRech = useCallback(async (value: string) => {
    setRech(value);
  }, []);

  const expandChange = useCallback(
    (event: GridExpandChangeEvent) => {
      if (event.dataIndex !== -1) {
        let i = groupProduit.findIndex(
          (e) => e.prod_num === event.dataItem.prod_num
        );
        dispatch(
          planoAPI.util.updateQueryData(
            "getPlanogramme",
            {
              first: groupBys.join(","),
              mag,
              banniere: ban,
              section,
              four,
              div,
              page: 1,
              rech,
              limite: pageSize,
              acht: user,
              act: currentAcc,
              toSort: toSort,
              order: order,
              statut,
              mode,
              coll: collection,
            },
            (planogramme) => {
              planogramme[i].expanded =
                planogramme[i].expanded === undefined
                  ? true
                  : !planogramme[i].expanded;
              planogramme[i].selected = planogramme[i].selected = false;
              return planogramme;
            }
          )
        );
      } else {
        let groupId = event.dataItem.field + "_" + event.dataItem.value;
        if (!collapsedGroups.includes(groupId)) {
          setCollapsedGroups([...collapsedGroups, groupId]);
        } else {
          setCollapsedGroups(collapsedGroups.filter((gr) => gr !== groupId));
        }
      }
    }, [ban, collapsedGroups, collection, currentAcc, dispatch, div, groupBys, four, groupProduit, mag, mode, order, pageSize, rech, section, statut, toSort, user]);

  useEffect(() => {

    let i = groupProduit.findIndex((e) => e.prod_num === parseInt(rech));

    if (i !== -1) {
      dispatch(
        planoAPI.util.updateQueryData(
          "getPlanogramme",
          {
            first: groupBys.join(','),
            mag,
            banniere: ban,
            section,
            four,
            div,
            page: 1,
            rech,
            limite: pageSize,
            acht: user,
            act: currentAcc,
            toSort: toSort,
            order: order,
            statut,
            mode,
            coll: collection,
          },
          (planogramme) => {
            planogramme[i].selected = planogramme[i].selected = true;

            return planogramme;
          }
        )
      );
      if (page === 1) {
        document.querySelector(`[data-grid-row-index="${i}"]`)?.scrollIntoView({
          behavior: "auto",
          block: "center",
        });
      }
    }
  }, [ban, collection, currentAcc, dispatch, div, groupBys, four, groupProduit, mag, mode, order, page, pageSize, rech, section, statut, toSort, user]);

  useMemo(() => {
    if (document.querySelector(".k-grid-content") !== null) {
      let gridContainer = document.querySelector(".k-grid-content");
      gridContainer!.scrollTop = 0;
    }
  }, [mag, ban, section, div, user, currentAcc, toSort, order]);

  const handleClick = useCallback(
    (event: GridRowClickEvent) => {
      let i = groupProduit.findIndex(
        (e) => e.prod_num === event.dataItem.prod_num
      );
      if (i !== -1)
        dispatch(
          planoAPI.util.updateQueryData(
            "getPlanogramme",
            {
              first: groupBys.join(","),
              mag,
              banniere: ban,
              section,
              four,
              div,
              page: 1,
              rech,
              limite: pageSize,
              acht: user,
              act: currentAcc,
              toSort: toSort,
              order: order,
              statut,
              mode,
              coll: collection,
            },
            (planogramme) => {
              planogramme.forEach((e) => (e.selected = false));
              planogramme[i].selected = planogramme[i].selected = true;
              return planogramme;
            }
          )
        );
    },
    [ban, collection, currentAcc, dispatch, div, groupBys, four, groupProduit, mag, mode, order, pageSize, rech, section, statut, toSort, user]
  );

  const dataStateChange = async (event: GridDataStateChangeEvent) => {
    setToSort("");

    const newGroupBy: string[] = event.dataState.group?.map((e) => e.field) || [];

    if (newGroupBy?.length === 0) {
      localStorage.removeItem("groupBy");
    } else {
      localStorage.setItem("groupBy", newGroupBy.join(','));
    }

    let gridContainer = document.querySelector(".k-grid-content");
    gridContainer!.scrollTop = 0;
    setPrev(0);
    setGroupBys(newGroupBy);
    setPage(1);

    const newDataState: State = {
      group: newGroupBy
        ? newGroupBy.map((item) => ({ field: item, dir: undefined }))
        : undefined,
    };
    setDataState(newDataState);
  };

  const isRowInViewport = (rowElement: Element) => {
    const rowRect = rowElement.getBoundingClientRect();
    const tableRect = document
      .getElementsByClassName("k-grid-aria-root")[0]!
      .getBoundingClientRect();

    return rowRect.top >= tableRect.top && rowRect.bottom <= tableRect.bottom;
  };

  const updateActiveSection = useCallback(
    (event: GridEvent) => {
      let rows = event.target!.element!.querySelectorAll(
        ".k-table-row.k-master-row"
      );
      let first: any = "";
      let num: number = 0;
      let magasin: string = "";
      let mag_num: number = 0;

      rows.forEach((e: Element, i: number) => {
        if (isRowInViewport(e) && first === "") {
          if (e.id) {
            let groupe = groupProduit.find(
              (g) => g.prod_num.toString() === e.id
            );
            first = groupe!.plans_nom;
            num = groupe!.plans_seq;
            magasin = groupe?.mag_nom ? groupe?.mag_nom : "";
            mag_num = groupe?.mag_num ? groupe?.mag_num : 0;
          }
          return;
        }
      });

      setActiveSection(first);
      setActiveSectionNum(num);
      if (magasin && mag_num) {
        setActiveMagasin(magasin);
        setActiveMagasinNum(mag_num);
      }
    },
    [groupProduit]
  );

  const scrollHandler = useCallback(
    (event: GridEvent) => {
      if (
        !rech &&
        page < Math.ceil(groupProduit[0]?.nbr_total_grp / pageSize)
      ) {
        updateActiveSection(event);
        if (event.nativeEvent.target.scrollTop > prev) {
          setPrev(event.nativeEvent.target.scrollTop);
          if (isFetchingPlanogrammes || isLoading) return;

          const e = event.nativeEvent;
          if (
            e.target.scrollTop + 100 >=
            e.target.scrollHeight - e.target.clientHeight
          ) {
            let allTr = document.querySelectorAll(".k-master-row");
            let lastTr = allTr[allTr.length - 1];
            setPage(page + 1);
            lastTr.scrollIntoView(true);
          }
        } else if (
          prev >
          event.nativeEvent.target.scrollHeight -
          event.nativeEvent.target.clientHeight
        ) {
          setPrev(event.nativeEvent.target.scrollTop);
        }
      }
    },
    [groupProduit, isFetchingPlanogrammes, isLoading, page, pageSize, prev, rech, updateActiveSection]);

  const handleCloseMod = useCallback(() => {
    if (modalOpened.length === 0) setAnchorEl(null);
    setShowContextualMenu(false);
  }, [modalOpened.length]);

  const handleShowAddMagasin = () => {
    setShowAddMagasin(true);
    setShowContextualMenu(false);
  }

  const handleOpenRemplacePar = useCallback(async () => {
    setOpenRemplacePar(true);
    setShowContextualMenu(false);
    const plano = await trigger({
      prod: selectedRow!.toString(),
      statut: "",
      ban: "",
      mag: "",
      manquant: false,
    }).unwrap();
    setListMags(plano.map((e) => e.magasin));
  }, [selectedRow, trigger]);

  const handleCloseRemplacePar = () => {
    setOpenRemplacePar(false);
    setListMags([]);
    setAnchorEl(null);
  };

  const handleEditModal = () => {
    setOpenModalEdit(true);
    setShowContextualMenu(false);
  };
  const handleCloseEditModal = () => {
    if (unsaved) {
      if (window.confirm("Vous avez des modifications non sauvegardées!")) {
        setSelectedRow(null);
        setOpenModalEdit(false);
        setAnchorEl(null);
      } else {
        return;
      }
    }
    setListMags([]);
    setSelectedRow(null);
    setOpenModalEdit(false);
    setAnchorEl(null);
  };

  const handleSort = useCallback(
    (e: any) => {
      if (sortableFields.includes(e.sort[0].field)) {
        if (!groupBys?.includes(e.sort[0].field)) {
          if (toSort === "") {
            setOrder(order === "" ? "asc" : "desc");
            setToSort(e.sort[0].field);
          } else if (toSort !== e.sort[0].field) {
            setOrder("asc");
            setToSort(e.sort[0].field);
          } else {
            setOrder(order === "asc" ? "desc" : "");
            setToSort(order === "asc" ? toSort : "");
          }
        } else {
          dispatch(
            addNotificationMessages({
              message: "Impossible de trier un groupBy",
              code: ResponseTypes.WARNING,
              id: Math.random(),
            })
          );
        }
      }
    },
    [dispatch, groupBys, order, toSort]
  );

  const handleContextMenu = useCallback(
    (event: GridContextMenuEvent) => {
      let i = groupProduit.findIndex(
        (e) => e.prod_num === event.dataItem.prod_num
      );
      if (i !== -1) {
        dispatch(
          planoAPI.util.updateQueryData(
            "getPlanogramme",
            {
              first: groupBys.join(','),
              mag,
              banniere: ban,
              section,
              four,
              statut,
              div,
              page: 1,
              rech,
              limite: pageSize,
              acht: user,
              act: currentAcc,
              toSort: toSort,
              order: order,
              mode,
              coll: collection,
            },
            (planogramme) => {
              planogramme.forEach((e) => (e.selected = false));
              planogramme[i].selected = planogramme[i].selected = true;
            }
          )
        );
        if (event.field) setShowAddMagasinMenu(false);
        setActiveSectionNum(event.dataItem.plans_seq);
        setSelectedRow(event.dataItem.prod_num);

        setSelectedProduct(event.dataItem);
        setAnchorEl(event.nativeEvent.target);
      }
    },
    [ban, collection, currentAcc, dispatch, div, groupBys, four, groupProduit, mag, mode, order, pageSize, rech, section, statut, toSort, user]
  );

  const onContextMenu = useCallback(
    (event: GridContextMenuEvent) => {
      event.nativeEvent.preventDefault();
      handleContextMenu(event);
    },
    [handleContextMenu]
  );

  const HeaderWithSort = useCallback(
    (props: GridHeaderCellProps & { tooltip: string }) => {
      let tooltipParagraphs: JSX.Element[] = [];

      if (props.tooltip !== undefined) {
        tooltipParagraphs = (props.tooltip || "")
          .split(/(?=\b\w+:)/)
          .map((segment, index) => <p key={index}>{segment.trim()}</p>);
      }

      const isEmptyTooltip =
        tooltipParagraphs.length === 1 &&
        tooltipParagraphs[0].props.children === "";

      let sortIcon;
      switch (order) {
        case "asc":
          sortIcon = <span className="k-icon k-font-icon k-i-arrow-down" />;
          break;
        case "desc":
          sortIcon = <span className="k-icon k-font-icon k-i-arrow-up" />;
          break;
        default:
          sortIcon = <span></span>;
      }

      return (
        <span className="k-cell-inner">
          <span
            className="k-link"
            onClick={props.onClick}
          >
            {toSort === props.field && sortIcon}
            {!isEmptyTooltip
              ? (
                <Tooltip title={parse(props.tooltip ?? "")}>
                  <span className="k-column-title">{props.title}</span>
                </Tooltip>
              )
              : (<span className="k-column-title">{props.title}</span>)
            }
            {props.children}
            {props.field !== undefined && sortableFields.includes(props.field) && (
              <Box
                className="k-icon k-font-icon k-i-arrows-swap "
                sx={{ pl: 1 }}
              />
            )}
          </span>
          <GridColumnMenuWrapper {...props.columnMenuWrapperProps} />
        </span>

      );
    },
    [order, toSort]
  );

  const handleApplicat = useCallback(() => {
    let token = localStorage.getItem("token")?.split(" ")[1];
    let user = localStorage.getItem("user");
    window.open(
      process.env.REACT_APP_ENV === "DEV"
        ? `https://publicite-dev.tanguay.ca/#/Inventaire/Produit=${selectedRow}?token=${token}&user=${user}`
        : `https://publicite.tanguay.ca/#/Inventaire/Produit=${selectedRow}?token=${token}&user=${user}`
    );
    setShowContextualMenu(false);
  }, [selectedRow]);

  const handleOpenStatsModal = () => {
    setOpenModalStats(true);
    setShowContextualMenu(false);
  }

  const DetailComponentWrapper = useCallback(
    (gridDetailRowProps: GridDetailRowProps) => {
      return (
        <DetailComponent
          prod={gridDetailRowProps.dataItem.prod_num}
          statut={statut}
          ban={ban}
          mag={mag}
          setShowAddMagasin={setShowAddMagasinMenu}
          setListMags={setListMags}
        ></DetailComponent>
      );
    },
    [ban, mag, statut]
  );

  interface BooleanMap {
    [key: string]: boolean;
  }
  const labelConditions: BooleanMap = useMemo(() => ({
    un_magasin: magasinsSelected.length === 1,
  }), [magasinsSelected.length]);

  const onColumnsSubmit = useCallback((newColumns: Header[]) => {
    setColumns(newColumns);

    userPreferencesHook.setColumnsPreferences(newColumns);
  }, [userPreferencesHook]);

  const gridColumns = useMemo(() => {
    var retour =
      groupProduit &&
      columns
        .filter((column: Header) => buttonsState.storeView || column.field !== "mag_nom")
        .map((column: Header, index: number) => {
          if (column.isDisplayed) {
            return (
              <Column
                headerCell={(props) => (
                  <HeaderWithSort
                    {...props}
                    tooltip={column.tooltip!}
                  />
                )}
                columnMenu={props => (
                  <CustomColumnMenu
                    {...props}
                    columns={columns}
                    onColumnsSubmit={onColumnsSubmit}
                  />
                )}
                field={column.field}
                key={column.fieldLabel}
                title={
                  column.alternativeFieldLabel
                    ? labelConditions[column.fieldCondition ?? ""]
                      ? column.alternativeFieldLabel
                      : column.fieldLabel
                    : column.fieldLabel
                }
                format={column.fieldFormat}

                width={column.width}
                headerClassName={`${column.fieldFormat === "{0:c}" ? "alignRight" : ""
                  }`}
                className={`${column.fieldFormat === "{0:c}" ? "alignRight" : ""
                  }`}
                cells={{
                  data: 
                    column.customCell ? customCellFeed(column.customCell) : undefined,
                }}
              />
            );
          } else {
            return (
              <Column
                field={column.field}
                key={column.fieldLabel}
                title={column.fieldLabel}
                width={0}
                headerClassName={`${column.fieldFormat === "{0:c}" ? "alignRight" : ""}`}
                className={`${column.fieldFormat === "{0:c}" ? "alignRight" : ""}`}
              />
            );
          }
        });

    return retour;
  }, [HeaderWithSort, buttonsState.storeView, columns, groupProduit, labelConditions, onColumnsSubmit]);

  const handleGroupState = useMemo(() =>
  ({
    data: mapTree(
      dataResult.data,
      "items",
      (group) => {
        if (!group.aggregates) return group;
        let groupId = group.field + "_" + group.value;
        return { ...group, expanded: !collapsedGroups.includes(groupId) };
      }),
    total: dataResult.total,
  } as DataResult)
    ,
    [collapsedGroups, dataResult.data, dataResult.total]
  );

  const handleColumnReorder = useCallback((event: GridColumnReorderEvent) => {

    const orderedColumns = (event.columns as Array<GridColumnProps & {orderIndex : number}>)
      .toSorted((a, b) => a.orderIndex! - b.orderIndex!)
      .map((column) => (
        {
          field: column.field,
          width: column.width,
          isDisplayed: !!(column.width && parseInt(column.width as string) > 0),
        } as Header));

    userPreferencesHook.setColumnsPreferences(orderedColumns);
  }, [userPreferencesHook]);

  const handleUpdate = useCallback((updatedProduct: Produit) => {
    setGroupProduit(prev =>
      [...prev.map(previousProduct => {
        if (previousProduct.prod_num === updatedProduct.prod_num) {
          const updated = { ...previousProduct, ...updatedProduct } as unknown as GroupProduit;
          setSelectedProduct(updated);
          return updated;
        }
        else {
          return previousProduct
        }
      })]
    );

  }, [setGroupProduit, setSelectedProduct]);

  const toolbar = useMemo(() =>
    <Toolbar
      setAddProductTitle={setAddProductTitle}
      setOpenNewProduit={setOpenNewProduit}
      setSelectedRow={setSelectedRow}
      user={acheteursSelected}
      ban={bannieresSelected}
      mag={magasinsSelected}
      div={divisionsSelected}
      section={sectionsSelected}
      currentAcc={activitesSelected}
      statut={statutsSelected}
      four={fournisseursSelected}
      collection={collectionsSelected}
      setCollection={setCollection}
      setAcheteur={setUser}
      setActivite={setCurrentAcc}
      setBanniere={setBan}
      setDivision={setDiv}
      setFournisseur={setFour}
      setMagasin={setMag}
      setSection={setSection}
      setStatut={setStatut}
      updateObject={updateObject}
    />
    , [acheteursSelected, activitesSelected, bannieresSelected, collectionsSelected, divisionsSelected, fournisseursSelected, magasinsSelected, sectionsSelected, statutsSelected, updateObject]);

  const grid = useMemo(() => {
    return (
      <GridWrapper>
        {buttonsState.productView ? (
          <CustomGrid
            data={
              groupProduit.length > 0 &&
                (!isError || (isError && (error as APIError).status !== 404))
                ? handleGroupState
                : []
            }
            dataStateChange={dataStateChange}
            detail={DetailComponentWrapper}
            expandChange={expandChange}
            handleClick={handleClick}
            handleSort={handleSort}
            handleColumnReorder={handleColumnReorder}
            onContextMenu={onContextMenu}
            pageSize={pageSize}
            scrollHandler={scrollHandler}
            dataState={dataState}
            toolbar={toolbar}
            rows={gridColumns}
            id="prod_num"
            isPlanoGroupe={true}
          />
        ) : (
          <CustomGrid
            data={
              groupProduit.length > 0 &&
                (!isError || (isError && (error as APIError).status !== 404))
                ? handleGroupState
                : []
            }
            dataStateChange={dataStateChange}
            handleClick={handleClick}
            handleSort={handleSort}
            handleColumnReorder={handleColumnReorder}
            onContextMenu={onContextMenu}
            pageSize={pageSize}
            scrollHandler={scrollHandler}
            dataState={dataState}
            toolbar={toolbar}
            rows={gridColumns}
            id="prod_num"
          />
        )}
      </GridWrapper>
    );
  }, [buttonsState.productView, groupProduit.length, isError, error, handleGroupState, DetailComponentWrapper, expandChange, handleClick, handleSort, handleColumnReorder, onContextMenu, pageSize, scrollHandler, dataState, toolbar, gridColumns]);

  const contextMenu = useMemo(() => {
    return (
      <ClickAwayListener onClickAway={handleCloseMod}>
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={showContextualMenu}
          onClose={handleCloseMod}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          disableAutoFocusItem={true}
        >
          <MenuItem disabled={!d_inv170.canRead} onClick={handleApplicat}>
            Inventaire
          </MenuItem>
          <MenuItem onClick={handleOpenStatsModal}>Stats</MenuItem>
          <MenuItem disabled={!prod_plano.canModify} onClick={handleEditModal}>
            Modifier
          </MenuItem>
          {!showAddMagasinMenu && (
            <MenuItem
              disabled={!prod_plano.canAdd}
              onClick={handleOpenRemplacePar}
            >
              Remplacé par
            </MenuItem>
          )}
          {showAddMagasinMenu && (
            <MenuItem
              disabled={!prod_plano.canAdd}
              onClick={handleShowAddMagasin}
            >
              Ajouter le magasin
            </MenuItem>
          )}
          <MenuItem onClick={handleCloseMod}>Annuler</MenuItem>
        </Menu>
      </ClickAwayListener>
    );
  }, [anchorEl, d_inv170.canRead, handleApplicat, handleCloseMod, handleOpenRemplacePar, prod_plano.canAdd, prod_plano.canModify, showAddMagasinMenu, showContextualMenu])

  const filteredResults = useMemo(() => {

    return isSuccessPlanogrammes && planogrammes.length > 0
      ? planogrammes[0].nbr_total_grp
      : 0;

  }, [isSuccessPlanogrammes, planogrammes]);

  return (
    <GridContext.Provider value={{ selectedData: selectedProduct, updateRow: handleUpdate }}>
      <div
        style={{ width: "100%" }}
      >
        {contextMenu}
        {groupProduit && (
          <Box>
            <GenericModal
              title={`Modification du PTR:  ${padZerosLeft(
                selectedRow!,
                PTR_LENGTH
              )}`}
              open={openModalEdit}
              handleClose={handleCloseEditModal}
              style={getModalStyle}
            >
              <Box>
                <WrapperEditMagasin
                  prod={selectedRow}
                  setSelectedRow={setSelectedRow}
                  setUnsaved={setUnsaved}
                  setOpenNewProduit={setOpenNewProduit}
                  setOpenModalEdit={setOpenModalEdit}
                  setAddProductTitle={setAddProductTitle}
                  setListMags={setListMags}
                  magasins={magasins}
                />
              </Box>
            </GenericModal>
            <GenericModal
              open={open}
              handleClose={handleClose}
              title="Modification de magasins"
              style={getModalStyle}
            >
              <WrapperMagasin
                mag={mag}
                sec={activeSectionNum}
                plans_nom={activeSection}
              />
            </GenericModal>
            <GenericModal
              open={openNewProduit}
              handleClose={handleCloseNewProduit}
              style={getModalStyle}
              title={addProductTitle}
            >
              <FormNewProduit
                row={selectedRow}
                defaultDisabled={true}
                prendLaPlaceDe={null}
                showMagList={false}
                listMagsPlano={listMags}
                activeSectionNum={activeSectionNum}
              />
            </GenericModal>
            <GenericModal
              open={openRemplacePar}
              handleClose={handleCloseRemplacePar}
              style={getModalStyle}
              title={"Ajouter un produit"}
            >
              <FormNewProduit
                row={null}
                defaultDisabled={false}
                prendLaPlaceDe={selectedRow}
                showMagList={true}
                listMagsPlano={listMags}
                activeSectionNum={activeSectionNum}
              />
            </GenericModal>
            <GenericModal
              open={showAddMagasin}
              handleClose={() => {
                setShowAddMagasin(false);
                setAnchorEl(null);
              }}
              style={getModalStyle}
              title={"Ajouter un magasin"}
            >
              <FormNewProduit
                row={selectedRow}
                defaultDisabled={false}
                prendLaPlaceDe={null}
                showMagList={true}
                listMagsPlano={listMags}
                activeSectionNum={activeSectionNum}
              />
            </GenericModal>
            <GenericModal
              open={openModalStats}
              handleClose={handleCloseModalStats}
              title={`Vente collection: ${selectedRow}`}
              style={getModalStyle}
            >
              <StatsModalComponent prod={selectedRow} />
            </GenericModal>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            height: `calc(100vh - ${sizeConfigs.topbar.height})`,
          }}
        >
          {headerExpanded && (
            <Box
              sx={{
                width: sizeConfigs.sidebar.width,
                minHeight: "50px",
                whiteSpace: "nowrap",
                padding: "10px",
              }}
            >
              <HeaderPlano
                user={acheteursSelected}
                ban={bannieresSelected}
                mag={magasinsSelected}
                div={divisionsSelected}
                section={sectionsSelected}
                currentAcc={activitesSelected}
                statut={statutsSelected}
                four={fournisseursSelected}
                handleRech={handleRech}
                setUser={setUser}
                rech={rech}
                sections={sections}
                users={users}
                allBan={bannieres}
                allMag={magasins}
                allDiv={divisions}
                acc={activites}
                statuts={statuts}
                fournisseurs={fournisseurs}
                activitesChildren={activitesChildren}
                bannieresChildren={bannieresChildren}
                divisionsChildren={divisionsChildren}
                fournisseursChildren={fournisseursChildren}
                statutsChildren={statutsChildren}
                allCollections={collections}
                collection={collectionsSelected}
                collectionsChildren={collectionsChildren}
                resetPage={resetPage}
                filteredResults={filteredResults}
              />
            </Box>
          )}
          <Box
            sx={{
              width: `${headerExpanded
                ? `calc(100vw - ${sizeConfigs.sidebar.width})`
                : "100vw"
                }`,
            }}
          >
            {grid}
            <Box
              sx={{
                backgroundColor: "#d0d0d0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography sx={{ color: "#7b7b7b", fontWeight: "bold", p: 1 }}>
                {
                  planogrammes[0]?.nbr_total_grp
                    ? `${planogrammes.length} / ${planogrammes.at(0)?.nbr_total_grp}`
                    : "N/D"
                }
              </Typography>
            </Box>
            {/* {groupProduit.length > 0 && // TODO: see Footer.tsx
          <Footer
            activeSectionNum={activeSectionNum}
            activeSection={activeSection}
            activeMagasin={activeMagasin}
            current={groupProduit.length}
            total={groupProduit[0]?.nbr_total_grp}
            footer={footer}
            handleOpen={() => setOpen(true)}
          />
          } */}
          </Box>
        </Box>
      </div>
    </GridContext.Provider>
  );

}

